import type { ErrorComponentProps } from "@tanstack/react-router";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

export function RouteError({ error, reset }: ErrorComponentProps) {
  return (
    <div className="w-full max-w-2xl space-y-4 px-6 py-12">
      <Alert variant="destructive" className="rounded-xl">
        <AlertTitle>Something went wrong</AlertTitle>
        <AlertDescription>{error.message}</AlertDescription>
      </Alert>
      <Button onClick={() => reset()} variant="outline" className="rounded-full">
        Try again
      </Button>
    </div>
  );
}
